import {FormInput} from "../FormComponents/Input/Input";
import {Button, ButtonOption} from "../Fundamentals/Button";
import React, {useEffect} from "react";
import {useDispatch} from "react-redux";
import actionLogActions from "../../Actions/actionLogActions";
import {useTranslation} from "react-i18next";


export const SkynetLogSearch = ({ customer }) => {
    const { t } = useTranslation();
    const dispatch =  useDispatch();

    const [customerNumber, setCustomerNumber] = React.useState(customer?.vbCustomer?.customerNumber);
    useEffect(() => {
        if (customerNumber)
            dispatch(actionLogActions.getCustomerActionLog(customerNumber));

    }, []);

    const onSubmit = () => {
        dispatch(actionLogActions.getCustomerActionLog(customerNumber));
    }

    return (
        <div className="d-grid grid-cols-3">
            <fieldset className="d-grid gap-16">
                <div>
                    <FormInput required={true} label={t("common.customernumber")} disabled={!!customer} value={customerNumber} onChange={(value) => setCustomerNumber(value)}/>
                </div>
                <div className={"d-grid justify-content-end"}>
                    <Button option={ButtonOption.PRIMARY} onClick={onSubmit}>{t("common.search")}</Button>
                </div>
            </fieldset>
            <fieldset className="d-grid gap-16 ml-24 mt-24">
                <div>{t("loggingContainer.skynetLogDescription")}</div>
            </fieldset>
        </div>)
}